// extracted by mini-css-extract-plugin
var _1 = "AttachTasksModalTableRow-moduleAttachTasksModalTableRow__VD49S TableComponent-modulerow__xPAo4";
var _2 = "AttachTasksModalTableRow-modulereadonly__tSr1M";
export { _1 as "AttachTasksModalTableRow", _2 as "readonly" }
